var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { computed } from '@ember/object';
import { captureException, withScope } from '@sentry/ember';
import { EntityIdentifier, PickupSettings, DeliverySettings, FulfillmentConfiguration } from '@square/dashboard-protos/models/squareup/channelcontrols/configuration/models';
import { parsePrepTimeDuration, PREP_TIME_DURATION_TRANSLATION_KEYS } from '@dashboard/shared-ui/utils/prep-time';
import { EnablementStatus } from '@square/dashboard-protos/models/squareup/channelcontrols/configuration/enums';
import { feature } from '@square/ember-features/macros';
import { set as setToLocalStorage, get as getFromLocalStorage } from '@square/dashboard-utilities/utils/persistable';
import { OneTrustConsent } from '@square/dashboard-utilities/utils/one-trust/one-trust-compliance';

// Location ID => intended state for enablement to be updated to
let CashLocalProfile = (_dec = feature('ecom/cash-local-menus-enabled'), _dec2 = feature('ecom/cash-local-seller-dashboard-subnav'), _dec3 = computed('isCashLocalMenusEnabled', 'userRailsPermissions.hasCashLocalEnabled', 'wasCashLocalOnboardingSuccessful', 'wasOnboardingSuccessful'), _dec4 = computed('prepTimesByLocation'), _dec5 = computed('pickupEnablementByLocation'), _dec6 = computed('pickupEnablementByLocation', 'locationMap', 'locationsWithPickupEnabled.length'), _dec7 = computed('deliveryEnablementByLocation'), _dec8 = computed('deliveryEnablementByLocation', 'locationMap', 'locationsWithDeliveryEnabled.length'), _dec9 = computed('fulfillmentConfigurationsByLocation'), _dec10 = computed('fulfillmentConfigurationsByLocation'), _dec11 = computed('fulfillmentPickupEnablementByLocation'), _dec12 = computed('fulfillmentDeliveryEnablementByLocation'), _dec13 = computed('fulfillmentPickupEnablementByLocation', 'fulfillmentLocationsWithPickupEnabled.length'), _dec14 = computed('fulfillmentDeliveryEnablementByLocation', 'fulfillmentLocationsWithDeliveryEnabled.length'), _class = class CashLocalProfile extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _initializerDefineProperty(this, "cashAppLocal", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _initializerDefineProperty(this, "store", _descriptor4, this);
    _initializerDefineProperty(this, "fulfillmentConfigurationApi", _descriptor5, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor6, this);
    _initializerDefineProperty(this, "userRailsPermissions", _descriptor7, this);
    _initializerDefineProperty(this, "isLoading", _descriptor8, this);
    _initializerDefineProperty(this, "error", _descriptor9, this);
    _initializerDefineProperty(this, "menuCount", _descriptor10, this);
    _initializerDefineProperty(this, "isAllLocationOrderingPaused", _descriptor11, this);
    _initializerDefineProperty(this, "isProfileInComplete", _descriptor12, this);
    _initializerDefineProperty(this, "unpausedLocationsCount", _descriptor13, this);
    _initializerDefineProperty(this, "locations", _descriptor14, this);
    _initializerDefineProperty(this, "allSubunits", _descriptor15, this);
    _initializerDefineProperty(this, "locationMap", _descriptor16, this);
    _initializerDefineProperty(this, "prepTimesByLocation", _descriptor17, this);
    _initializerDefineProperty(this, "pickupEnablementByLocation", _descriptor18, this);
    _initializerDefineProperty(this, "deliveryEnablementByLocation", _descriptor19, this);
    _initializerDefineProperty(this, "fulfillmentConfigurationsByLocation", _descriptor20, this);
    _initializerDefineProperty(this, "isCashLocalMenusEnabled", _descriptor21, this);
    _initializerDefineProperty(this, "isCashLocalSellerDashboardSubnavEnabled", _descriptor22, this);
    _defineProperty(this, "_cashLocalBrand", null);
  }
  async load() {
    if (!this.hasCashLocalEnabled) {
      return;
    }
    if (!this._cashLocalBrand) {
      const response = await this.cashAppLocal.fetchDefaultBrand();
      this._cashLocalBrand = response;
    }

    // Initialize location map and counts
    this.isAllLocationOrderingPaused = this.getAllLocationOrderingPaused();
    this.unpausedLocationsCount = this.getUnpausedLocationsCount();
    this.locationMap = Object.assign({}, ...this.locationConfigurations.map(s => ({
      [s.unit_token]: s.order_configuration
    })));
    const subunits = await this.loadLocations();
    this.isProfileInComplete = await this.showCompleteProfileSetup();
    await this.loadFulfillment(subunits);
  }
  async showCompleteProfileSetup() {
    if (!this.isCashLocalSellerDashboardSubnavEnabled) {
      return false;
    }
    await this.loadLocations();
    if (this.isOrderingPaused) {
      return true;
    }

    // No locations are configured
    const locationConfigurations = this.locationConfigurations;
    if (locationConfigurations.length === 0) {
      return true;
    }
    return false;
  }
  async onboard(brandSource) {
    try {
      const response = await this.cashAppLocal.onboardSquareMerchant(brandSource);
      if (response?.brand) {
        // Update the cache with the newly created brand
        this._cashLocalBrand = response.brand;

        // Initialize location map and counts with the new brand data
        this.isAllLocationOrderingPaused = this.getAllLocationOrderingPaused();
        this.unpausedLocationsCount = this.getUnpausedLocationsCount();
        this.locationMap = Object.assign({}, ...this.locationConfigurations.map(s => ({
          [s.unit_token]: s.order_configuration
        })));

        // Store successful onboarding in localStorage using GDPR-compliant utility
        setToLocalStorage(`cash-local-onboarding-success-${this.userInfo.merchantToken}`, 'true', OneTrustConsent.FUNCTIONAL);
      }
      return response;
    } catch (error) {
      this.error = error;
      this.captureException(error);
      return null;
    }
  }
  async loadLocations() {
    // Skip loading if we already have locations
    if (this.allSubunits.length > 0) {
      return this.allSubunits;
    }
    try {
      const locationsRecordArray = await this.store.findAll('merchant-subunit-detailed');
      this.locations = locationsRecordArray.toArray();

      // Create a map of payment capabilities directly from the loaded locations
      const locationPaymentMap = new Map();
      this.locations.forEach(location => {
        locationPaymentMap.set(location.token, Boolean(location.canAcceptPaymentCards));
      });

      // Update allSubunits with real data that matches the configured locations
      // Locations without configured locations are assumed to be inactive
      const configuredTokens = new Set(this.locationConfigurations.map(config => config.unit_token));
      this.allSubunits = this.locations.filter(location => configuredTokens.has(location.token)).map(location => {
        this.locationMap[location.token].name = location.nickname;
        const canTakePayments = locationPaymentMap.get(location.token);
        return {
          token: location.token,
          nickname: location.nickname || location.merchantProfile?.name || 'Unnamed Location',
          isOrderingAllowed: !this.locationMap[location.token].ordering_paused,
          locationCanTakePayments: canTakePayments
        };
      });
    } catch {
      this.allSubunits = [];
    }
    return this.allSubunits;
  }
  async loadFulfillment(subunits) {
    // Skip loading if we already have fulfillment data
    if (Object.keys(this.prepTimesByLocation).length > 0) {
      return;
    }

    // If no subunits, initialize empty fulfillment data
    if (subunits.length === 0) {
      this.fulfillmentConfigurationsByLocation = {};
      this.prepTimesByLocation = {};
      this.pickupEnablementByLocation = {};
      this.deliveryEnablementByLocation = {};
      return;
    }
    const responses = await Promise.all(subunits.map(subunit => this.getLocationFulfillmentConfig(subunit)));

    // Store the full fulfillment configurations
    this.fulfillmentConfigurationsByLocation = subunits.reduce((result, subunit, index) => {
      const config = responses[index];
      if (config) {
        return {
          ...result,
          [subunit.token]: config
        };
      }
      return result;
    }, {});
    this.prepTimesByLocation = subunits.reduce((result, subunit, index) => {
      const prepTime = responses[index]?.pickupSettings?.prepTimeDuration || '';
      return {
        ...result,
        [subunit.token]: prepTime
      };
    }, {});
    this.pickupEnablementByLocation = subunits.reduce((result, subunit, index) => {
      const enablement = responses[index]?.pickupSettings?.enablementStatus || EnablementStatus.DISABLED;
      return {
        ...result,
        [subunit.token]: enablement
      };
    }, {});
    this.deliveryEnablementByLocation = subunits.reduce((result, subunit, index) => {
      const enablement = responses[index]?.deliverySettings?.enablementStatus || EnablementStatus.DISABLED;
      return {
        ...result,
        [subunit.token]: enablement
      };
    }, {});
  }
  async getLocationFulfillmentConfig(subunit) {
    try {
      const entity = new EntityIdentifier.Builder().merchantId(this.userInfo.merchantToken).locationId(subunit.token).channelId(this.brandChannelId).build();
      const resolvedConfig = await this.fulfillmentConfigurationApi.readEntityConfiguration(entity);
      return resolvedConfig;
    } catch {
      return undefined;
    }
  }
  async updateLocationPrepTime(locationId, prepTime) {
    const entity = new EntityIdentifier.Builder().merchantId(this.userInfo.merchantToken).locationId(locationId).channelId(this.brandChannelId).build();

    // Get current enablement status from the stored fulfillment configuration
    const currentConfig = this.fulfillmentConfigurationsByLocation[locationId];
    const pickupEnabled = currentConfig?.pickupSettings?.enablementStatus === EnablementStatus.ENABLED;
    const deliveryEnabled = currentConfig?.deliverySettings?.enablementStatus === EnablementStatus.ENABLED;

    // Build pickup settings if pickup is enabled
    let pickupSettings;
    if (pickupEnabled) {
      pickupSettings = new PickupSettings.Builder().prepTimeDuration(prepTime).enablementStatus(EnablementStatus.ENABLED).build();
    }

    // Build delivery settings if delivery is enabled
    let deliverySettings;
    if (deliveryEnabled) {
      deliverySettings = new DeliverySettings.Builder().prepTimeDuration(prepTime).enablementStatus(EnablementStatus.ENABLED).build();
    }

    // If neither pickup nor delivery is enabled, default to updating pickup only
    if (!pickupEnabled && !deliveryEnabled) {
      pickupSettings = new PickupSettings.Builder().prepTimeDuration(prepTime).enablementStatus(EnablementStatus.DISABLED).build();
    }
    const config = new FulfillmentConfiguration.Builder().entity(entity).pickupSettings(pickupSettings).deliverySettings(deliverySettings).build();
    const updatedConfig = await this.fulfillmentConfigurationApi.upsertEntityConfiguration(config);
    return updatedConfig;
  }
  async updateLocationPickupEnabled(locationId, enabled) {
    const entity = new EntityIdentifier.Builder().merchantId(this.userInfo.merchantToken).locationId(locationId).channelId(this.brandChannelId).build();
    const updatedEnablementStatus = enabled ? EnablementStatus.ENABLED : EnablementStatus.DISABLED;
    const pickupSettings = new PickupSettings.Builder().enablementStatus(updatedEnablementStatus).build();
    const config = new FulfillmentConfiguration.Builder().entity(entity).pickupSettings(pickupSettings).build();
    const updatedConfig = await this.fulfillmentConfigurationApi.upsertEntityConfiguration(config);
    return updatedConfig;
  }
  async updateLocationsPickupEnabled(locationsToUpdate) {
    try {
      const locationUpdateArray = Object.entries(locationsToUpdate);
      const updates = locationUpdateArray.map(([locationId, updatedEnablement]) => {
        return this.updateLocationPickupEnabled(locationId, updatedEnablement);
      });
      if (updates.length === 0) {
        return;
      }
      const responses = await Promise.all(updates);
      // Update local state
      locationUpdateArray.forEach(([locationId], index) => {
        const updatedConfig = responses[index];
        const resEnablement = updatedConfig.pickupSettings?.enablementStatus;
        if (!resEnablement) {
          throw new Error('No enablement status in pickup response');
        }
        this.pickupEnablementByLocation = {
          ...this.pickupEnablementByLocation,
          [locationId]: resEnablement
        };

        // Preserve existing delivery settings when updating pickup
        const existingConfig = this.fulfillmentConfigurationsByLocation[locationId];
        const mergedConfig = new FulfillmentConfiguration.Builder().entity(updatedConfig.entity).pickupSettings(updatedConfig.pickupSettings).deliverySettings(updatedConfig.deliverySettings || existingConfig?.deliverySettings).genericSettings(updatedConfig.genericSettings).build();

        // Update the stored fulfillment configuration
        this.fulfillmentConfigurationsByLocation = {
          ...this.fulfillmentConfigurationsByLocation,
          [locationId]: mergedConfig
        };
      });
      this.showPickupEnablementSaveSuccessToast(responses);
    } catch {
      this.showPickupEnablementSaveErrorToast();
    }
  }
  async updateLocationDeliveryEnabled(locationId, enabled) {
    const entity = new EntityIdentifier.Builder().merchantId(this.userInfo.merchantToken).locationId(locationId).channelId(this.brandChannelId).build();
    const updatedEnablementStatus = enabled ? EnablementStatus.ENABLED : EnablementStatus.DISABLED;
    const deliverySettings = new DeliverySettings.Builder().enablementStatus(updatedEnablementStatus).build();
    const config = new FulfillmentConfiguration.Builder().entity(entity).deliverySettings(deliverySettings).build();
    const updatedConfig = await this.fulfillmentConfigurationApi.upsertEntityConfiguration(config);
    return updatedConfig;
  }
  async updateLocationsDeliveryEnabled(locationsToUpdate) {
    try {
      const locationUpdateArray = Object.entries(locationsToUpdate);
      const updates = locationUpdateArray.map(([locationId, updatedEnablement]) => {
        return this.updateLocationDeliveryEnabled(locationId, updatedEnablement);
      });
      if (updates.length === 0) {
        return;
      }
      const responses = await Promise.all(updates);
      // Update local state
      locationUpdateArray.forEach(([locationId], index) => {
        const updatedConfig = responses[index];
        const resEnablement = updatedConfig.deliverySettings?.enablementStatus;
        if (!resEnablement) {
          throw new Error('No enablement status in delivery response');
        }
        this.deliveryEnablementByLocation = {
          ...this.deliveryEnablementByLocation,
          [locationId]: resEnablement
        };

        // Preserve existing pickup settings when updating delivery
        const existingConfig = this.fulfillmentConfigurationsByLocation[locationId];
        const mergedConfig = new FulfillmentConfiguration.Builder().entity(updatedConfig.entity).pickupSettings(updatedConfig.pickupSettings || existingConfig?.pickupSettings).deliverySettings(updatedConfig.deliverySettings).genericSettings(updatedConfig.genericSettings).build();

        // Update the stored fulfillment configuration
        this.fulfillmentConfigurationsByLocation = {
          ...this.fulfillmentConfigurationsByLocation,
          [locationId]: mergedConfig
        };
      });
      this.showDeliveryEnablementSaveSuccessToast(responses);
    } catch {
      this.showDeliveryEnablementSaveErrorToast();
    }
  }
  async savePrepTime(locationIds, saveValue) {
    try {
      // Filter out locations where the location's prep time is already the same as the saved value
      const locationsToUpdate = locationIds.filter(locationId => {
        return saveValue !== this.prepTimesByLocation[locationId];
      });

      // Run all updates
      const updates = locationsToUpdate.map(locationId => {
        return this.updateLocationPrepTime(locationId, saveValue);
      });
      if (updates.length === 0) {
        return true;
      }
      const responses = await Promise.all(updates);

      // Update local state
      locationsToUpdate.forEach((locationId, index) => {
        const updatedConfig = responses[index];
        const updatedPrepTime = updatedConfig.pickupSettings?.prepTimeDuration;
        if (updatedPrepTime) {
          this.prepTimesByLocation = {
            ...this.prepTimesByLocation,
            [locationId]: updatedPrepTime
          };
        }
        // Update the stored fulfillment configuration
        this.fulfillmentConfigurationsByLocation = {
          ...this.fulfillmentConfigurationsByLocation,
          [locationId]: updatedConfig
        };
      });

      // Show success toast
      this.showPrepTimeSaveSuccessToast(saveValue);
      return true;
    } catch {
      this.showPrepTimeSaveErrorToast();
      return false;
    }
  }
  async updateOrderingConfiguration(orderingPaused, locations) {
    // Need to update some things here to support multiple locations
    this.isLoading = true;
    this.error = null;
    try {
      const response = await this.cashAppLocal.updateOrderingConfiguration(orderingPaused || false, locations || []);
      if (response) {
        // Update the local cache with the new ordering status.
        if (this._cashLocalBrand) {
          this._cashLocalBrand.location_configurations = locations || [];
        }
        if (response.ordering_paused !== undefined && this._cashLocalBrand) {
          this._cashLocalBrand.ordering_paused = response.ordering_paused;
        }

        // Update allSubunits with the response data
        if (response.location_configurations?.location_configuration) {
          response.location_configurations.location_configuration.forEach(config => {
            // Update allSubunits ordering status
            const subunit = this.allSubunits.find(s => s.token === config.unit_token);
            if (subunit) {
              subunit.isOrderingAllowed = !config.order_configuration.ordering_paused;
            }
          });

          // Update unpausedLocationsCount
          this.unpausedLocationsCount = this.allSubunits.filter(s => s.isOrderingAllowed).length;
          this.isAllLocationOrderingPaused = this.unpausedLocationsCount === 0;
        }
      }
      this.isLoading = false;
      return response;
    } catch (error) {
      this.error = error;
      this.isLoading = false;
      throw error;
    }
  }
  convertSubunitsToLocationConfigurations(selectedLocationTokens) {
    return this.allSubunits.map(subunit => ({
      unit_token: subunit.token,
      order_configuration: {
        ordering_paused: !selectedLocationTokens.includes(subunit.token)
      }
    }));
  }
  showPrepTimeSaveSuccessToast(prepTime) {
    try {
      const {
        quantity
      } = parsePrepTimeDuration(prepTime);
      this.marketToasts.success(this.intl.t('cashAppLocal.profileDropdown.prepTimeModal.toast.success', {
        count: quantity
      }), {
        showDismiss: true
      });
    } catch {
      // no-op
    }
  }
  showPrepTimeSaveErrorToast() {
    this.marketToasts.critical(this.intl.t('cashAppLocal.profileDropdown.prepTimeModal.toast.error'), {
      showDismiss: true
    });
  }
  showPickupEnablementSaveSuccessToast(configs) {
    let message = this.intl.t('cashAppLocal.profileDropdown.pickup.enablement.toast.multiple.success');
    if (configs.length === 1) {
      message = configs[0].pickupSettings?.enablementStatus === EnablementStatus.ENABLED ? this.intl.t('cashAppLocal.profileDropdown.pickup.enabled.toast.success') : this.intl.t('cashAppLocal.profileDropdown.pickup.disabled.toast.success');
    }
    this.marketToasts.success(message, {
      showDismiss: true
    });
  }
  showPickupEnablementSaveErrorToast() {
    this.marketToasts.critical(this.intl.t('cashAppLocal.profileDropdown.pickup.enablement.toast.error'), {
      showDismiss: true
    });
  }
  showDeliveryEnablementSaveSuccessToast(configs) {
    let message = this.intl.t('cashAppLocal.profileDropdown.delivery.enablement.toast.multiple.success');
    if (configs.length === 1) {
      message = configs[0].deliverySettings?.enablementStatus === EnablementStatus.ENABLED ? this.intl.t('cashAppLocal.profileDropdown.delivery.enabled.toast.success') : this.intl.t('cashAppLocal.profileDropdown.delivery.disabled.toast.success');
    }
    this.marketToasts.success(message, {
      showDismiss: true
    });
  }
  showDeliveryEnablementSaveErrorToast() {
    this.marketToasts.critical(this.intl.t('cashAppLocal.profileDropdown.delivery.enablement.toast.error'), {
      showDismiss: true
    });
  }
  get brandName() {
    return this._cashLocalBrand?.name || '';
  }
  get brandDescription() {
    return this._cashLocalBrand?.description || '';
  }
  get cashtag() {
    return this._cashLocalBrand?.cashtag || '';
  }
  get profileUrl() {
    return this._cashLocalBrand?.profile_url || '';
  }
  get cleanProfileUrl() {
    const rawUrl = this._cashLocalBrand?.profile_url;
    if (!rawUrl) {
      return '';
    }
    // Remove https:// and /ordering/ from the URL
    return rawUrl.replace('https://', '').replace('/order/', '/');
  }
  get artworkImageLightUrl() {
    return this._cashLocalBrand?.artwork_image?.light_url || '';
  }
  get artworkImageDarkUrl() {
    return this._cashLocalBrand?.artwork_image?.dark_url || '';
  }
  get backgroundColorLight() {
    return this._cashLocalBrand?.background_color?.light?.srgb || '';
  }
  get backgroundColorDark() {
    return this._cashLocalBrand?.background_color?.dark?.srgb || '';
  }
  get foregroundColorLight() {
    return this._cashLocalBrand?.foreground_color?.light?.srgb || '';
  }
  get foregroundColorDark() {
    return this._cashLocalBrand?.foreground_color?.dark?.srgb || '';
  }
  get isOrderingPaused() {
    // Ordering is paused if the top-level ordering_paused is true
    return this._cashLocalBrand?.ordering_paused || false;
  }
  get locationConfigurations() {
    return this._cashLocalBrand?.location_configurations || [];
  }
  get qrCodeImageUrl() {
    return this._cashLocalBrand?.profile_qr_code_url || '';
  }
  get hasLocations() {
    return this.allSubunits.length;
  }
  get brandToken() {
    return this._cashLocalBrand?.brand_token || '';
  }
  get brandChannelId() {
    return this._cashLocalBrand?.brand_channel_id || '';
  }
  get isProfileSetupNeeded() {
    return this.isProfileInComplete;
  }
  get hasCashLocalEnabled() {
    return this.wasCashLocalOnboardingSuccessful || this.userRailsPermissions.hasCashLocalEnabled;
  }
  getDefaultBrand() {
    return this._cashLocalBrand;
  }
  get canSeeCashLocalInMenus() {
    return this.wasCashLocalOnboardingSuccessful || this.userRailsPermissions.hasCashLocalEnabled && this.isCashLocalMenusEnabled;
  }
  get prepTimeDisplay() {
    const prepTimes = Object.values(this.prepTimesByLocation);
    if (prepTimes.length === 0) {
      return `15 ${this.intl.t('cashAppLocal.profileDropdown.prepTimeModal.mins')}`;
    }

    // If all locations have same prep time values, then show that value
    if (prepTimes.every(val => val === prepTimes[0])) {
      // If none of the locations have prep time
      if (prepTimes[0] === 'PT0M' || prepTimes[0] === '') {
        return this.intl.t('cashAppLocal.profileDropdown.prepTimeModal.noPrepTime');
      }

      // Parse prep time string and get appropriate display value
      try {
        const {
          timeUnit,
          quantity
        } = parsePrepTimeDuration(prepTimes[0]);
        if (PREP_TIME_DURATION_TRANSLATION_KEYS[timeUnit]) {
          return this.intl.t(PREP_TIME_DURATION_TRANSLATION_KEYS[timeUnit].translation, {
            count: quantity
          });
        }
      } catch {
        return this.intl.t('cashAppLocal.profileDropdown.prepTimeModal.noPrepTime');
      }
    }
    return this.intl.t('cashAppLocal.profileDropdown.prepTimeModal.prepTimesVary');
  }
  get locationsWithPickupEnabled() {
    return Object.entries(this.pickupEnablementByLocation).filter(([, enablement]) => enablement === EnablementStatus.ENABLED).map(([locationId]) => locationId);
  }
  get pickupEnablementDisplay() {
    const enablements = Object.values(this.pickupEnablementByLocation);
    if (enablements.length === 0) {
      return '';
    }

    // If all locations have same enablement status, then show that value
    if (enablements.every(val => val === enablements[0])) {
      return enablements[0] === EnablementStatus.ENABLED ? this.intl.t('common.on') : this.intl.t('common.off');
    }

    // Otherwise show # of enabled locations
    return this.intl.t('cashAppLocal.profileDropdown.row.locationCount', {
      count: this.locationsWithPickupEnabled.length
    });
  }
  get locationsWithDeliveryEnabled() {
    return Object.entries(this.deliveryEnablementByLocation).filter(([, enablement]) => enablement === EnablementStatus.ENABLED).map(([locationId]) => locationId);
  }
  get deliveryEnablementDisplay() {
    const enablements = Object.values(this.deliveryEnablementByLocation);
    if (enablements.length === 0) {
      return '';
    }

    // If all locations have same enablement status, then show that value
    if (enablements.every(val => val === enablements[0])) {
      return enablements[0] === EnablementStatus.ENABLED ? this.intl.t('common.on') : this.intl.t('common.off');
    }

    // Otherwise show # of enabled locations
    return this.intl.t('cashAppLocal.profileDropdown.row.locationCount', {
      count: this.locationsWithDeliveryEnabled.length
    });
  }

  // Proto-based computed properties that work directly with FulfillmentConfiguration data
  get fulfillmentPickupEnablementByLocation() {
    const result = {};
    Object.entries(this.fulfillmentConfigurationsByLocation).forEach(([locationId, config]) => {
      result[locationId] = config.pickupSettings?.enablementStatus || EnablementStatus.DISABLED;
    });
    return result;
  }
  get fulfillmentDeliveryEnablementByLocation() {
    const result = {};
    Object.entries(this.fulfillmentConfigurationsByLocation).forEach(([locationId, config]) => {
      result[locationId] = config.deliverySettings?.enablementStatus || EnablementStatus.DISABLED;
    });
    return result;
  }
  get fulfillmentLocationsWithPickupEnabled() {
    return Object.entries(this.fulfillmentPickupEnablementByLocation).filter(([, enablement]) => enablement === EnablementStatus.ENABLED).map(([locationId]) => locationId);
  }
  get fulfillmentLocationsWithDeliveryEnabled() {
    return Object.entries(this.fulfillmentDeliveryEnablementByLocation).filter(([, enablement]) => enablement === EnablementStatus.ENABLED).map(([locationId]) => locationId);
  }
  get fulfillmentPickupEnablementDisplay() {
    const enablements = Object.values(this.fulfillmentPickupEnablementByLocation);
    if (enablements.length === 0) {
      return this.intl.t('common.off');
    }

    // If all locations have same enablement status, then show that value
    if (enablements.every(val => val === enablements[0])) {
      return enablements[0] === EnablementStatus.ENABLED ? this.intl.t('common.on') : this.intl.t('common.off');
    }

    // Otherwise show # of enabled locations
    return this.intl.t('cashAppLocal.profileDropdown.row.locationCount', {
      count: this.fulfillmentLocationsWithPickupEnabled.length
    });
  }
  get fulfillmentDeliveryEnablementDisplay() {
    const enablements = Object.values(this.fulfillmentDeliveryEnablementByLocation);
    if (enablements.length === 0) {
      return this.intl.t('common.off');
    }

    // If all locations have same enablement status, then show that value
    if (enablements.every(val => val === enablements[0])) {
      return enablements[0] === EnablementStatus.ENABLED ? this.intl.t('common.on') : this.intl.t('common.off');
    }

    // Otherwise show # of enabled locations
    return this.intl.t('cashAppLocal.profileDropdown.row.locationCount', {
      count: this.fulfillmentLocationsWithDeliveryEnabled.length
    });
  }

  /**
   * Checks if the cash local onboarding was recently successful
   * @returns {boolean} true if onboarding was successful, false otherwise
   */
  get wasCashLocalOnboardingSuccessful() {
    return getFromLocalStorage(`cash-local-onboarding-success-${this.userInfo.merchantToken}`) === 'true';
  }

  // Helper methods to maintain backward compatibility
  getAllLocationOrderingPaused() {
    const locationConfigs = this.locationConfigurations || [];
    if (locationConfigs.length > 0) {
      return locationConfigs.some(config => config.order_configuration.ordering_paused === true);
    }
    // If there are no locations, we assume ordering is paused by default.
    // A user shouldn't be in this state.
    return true;
  }
  getUnpausedLocationsCount() {
    return this.locationConfigurations.filter(location => !location.order_configuration.ordering_paused).length;
  }
  captureException(error, context) {
    if (context) {
      withScope(scope => {
        scope.setContext('cashLocalProfileContext', context);
        captureException(error);
      });
    } else {
      captureException(error);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cashAppLocal", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "fulfillmentConfigurationApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "userRailsPermissions", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "error", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "menuCount", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "isAllLocationOrderingPaused", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "isProfileInComplete", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "unpausedLocationsCount", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "locations", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "allSubunits", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "locationMap", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "prepTimesByLocation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "pickupEnablementByLocation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "deliveryEnablementByLocation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "fulfillmentConfigurationsByLocation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "isCashLocalMenusEnabled", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "isCashLocalSellerDashboardSubnavEnabled", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "canSeeCashLocalInMenus", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "canSeeCashLocalInMenus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "prepTimeDisplay", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "prepTimeDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "locationsWithPickupEnabled", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "locationsWithPickupEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pickupEnablementDisplay", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "pickupEnablementDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "locationsWithDeliveryEnabled", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "locationsWithDeliveryEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deliveryEnablementDisplay", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "deliveryEnablementDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fulfillmentPickupEnablementByLocation", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "fulfillmentPickupEnablementByLocation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fulfillmentDeliveryEnablementByLocation", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "fulfillmentDeliveryEnablementByLocation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fulfillmentLocationsWithPickupEnabled", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "fulfillmentLocationsWithPickupEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fulfillmentLocationsWithDeliveryEnabled", [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, "fulfillmentLocationsWithDeliveryEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fulfillmentPickupEnablementDisplay", [_dec13], Object.getOwnPropertyDescriptor(_class.prototype, "fulfillmentPickupEnablementDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fulfillmentDeliveryEnablementDisplay", [_dec14], Object.getOwnPropertyDescriptor(_class.prototype, "fulfillmentDeliveryEnablementDisplay"), _class.prototype), _class);
export { CashLocalProfile as default };